import namespace from '../../config/Namespace';

const types = {
  actions: {
    resetList: 'resetList',
    setColumns: 'setColumns',
    setColumnVisibility: 'setColumnVisibility',
    setFilters: 'setFilters',
    fetchTopUps: 'fetchTopUps',
    fetchTopUpDetails: 'fetchTopUpDetails',
    fetchTopUpDetailsSuccess: 'fetchTopUpDetailsSuccess',
    fetchForeignAccounts: 'fetchForeignAccounts',
    fetchForeignAccountsSuccess: 'fetchForeignAccountsSuccess',
    fetchTopUpTransferTypesSuccess: 'fetchTopUpTransferTypesSuccess',
    fetchTopUpCreditTypes: 'fetchTopUpCreditTypes',
    fetchTopUpCreditTypesSuccess: 'fetchTopUpCreditTypesSuccess',
    fetchTopUpCredits: 'fetchTopUpCredits',
    fetchTopUpCreditsSuccess: 'fetchTopUpCreditsSuccess',
  },
};

export default namespace('TopUps', types);
